import Axios, { AxiosRequestConfig } from 'axios';

interface GraphQLRequest {
  query: string;
  variables: Record<string, any>;
}

interface GraphQLResponse {
  data?: any;
  errors?: Array<{ message: string }>;
}

/**
 * Generic GraphQL client for the dashboard API
 */
class GraphqlClient {
  // eslint-disable-next-line class-methods-use-this
  private get baseUrl(): string {
    return window.integrationLayer.dashboardGraphQlUrl;
  }

  /**
   * Get the request URL with optional operation name
   */
  private getUrl(operationName?: string): string {
    return operationName ? `${this.baseUrl}?name=${operationName}` : this.baseUrl;
  }

  /**
   * Execute a GraphQL query against the dashboard API
   * @param gqlRequest - The GraphQL request object
   * @param operationName - Optional operation name for monitoring/debugging
   */
  async query<T>(gqlRequest: GraphQLRequest, operationName?: string): Promise<T | null> {
    try {
      const config: AxiosRequestConfig = {
        url: this.getUrl(operationName),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(gqlRequest),
      };

      const response = await Axios(config);
      const result: GraphQLResponse = response.data;

      if (result.errors && result.errors.length > 0) {
        // eslint-disable-next-line no-console
        console.error('GraphQL errors:', result.errors);
        throw new Error(result.errors[0].message);
      }

      return result.data || null;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('GraphQL query error:', error);
      throw error;
    }
  }
}

const graphqlClient = new GraphqlClient();

export default graphqlClient;
